
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'

import CustomTagMixin from '@/@next/mixins/CustomTag'
import { PointsOfInterestService } from '@/@next/services'
import CPoiMiniCard from '@/components/cards/poi-mini-card'
import { CLazyLoadingImage } from '@/components/images'
import { CLoader } from '@/components/loader'
import { CImage } from '@/@next/components/image'
import { Maybe, MediaImage, PointOfInterestContentData, PointOfInterestContentHeadlineType } from '@/@types/graphql'
import { smallerImageUrl } from '@/@next/helpers'
import { PointOfInterest } from '@/@types/graphql'

const config = {
  name: 'c-content-poi',
  components: {
    ...CPoiMiniCard,
    CLazyLoadingImage,
    CLoader,
    CImage
  }
}

@Component(config)
export default class Poi extends Mixins(CustomTagMixin, PointsOfInterestService) {
  @Prop({ type: Object, required: true }) content!: any
  @Prop({ type: Object, required: false }) options!: any
  pointOfInterest: Maybe<Partial<PointOfInterest>> = null
  data!: PointOfInterestContentData

  @Watch('content')
  updateContent () {
    if (this.content && this.content.data.pointOfInterest) {
      this.pointOfInterest = this.content.data.pointOfInterest
      this.data = this.content.data
    }
  }

  // get data () {
  //   return this.content?.data as PointOfInterestContentData || 
  // }

  get imageUrl () {
    return this.pointOfInterest?.image?.file.url || null
  }

  get image () {
    return this.pointOfInterest?.image || null
  }

  get title () {
    return this.pointOfInterest?.i18n?.title?.value || null
  }

  mounted () {
    this.updateContent()
  }

  getBackupUrl (image: MediaImage) {
    if (!image.formats) return null
    return smallerImageUrl(image)
  }

  get headline () {
    // return this.$t('global.forFurther')
    if (this.data.headline) return this.$t('global.forFurther')
    switch (this.data.headlineType) {
      case PointOfInterestContentHeadlineType.Disabled: return null
      case PointOfInterestContentHeadlineType.Custom: return this.data.i18n.headline?.value.html || this.$t('global.forFurther') 
      default: return this.$t('global.forFurther') 
    }
    // if (this.data.headlineType === PointOfInterestContentTextType.Disabled) return null
    // if (this.data.textType === PointOfInterestContentTextType.ReadMore) return this.$t('global.forFurther')
    // return this.data.i18n.text
    // if (this.options?.disableSummary) return null
    // const summary = this.options?.summary
    // if (!summary) return this.$t('global.forFurther')
    // const { isEnabled, text } = this.options?.summary
    // if (!isEnabled) return null
    // if (!text) return this.$t('global.forFurther')
    // const translation = text.find((el: any) => el.language === this.$i18n.locale)
    //   || text.find((el: any) => el.language === 'fr')
    // if (!translation) return this.$t('global.forFurther')
    // return translation.value.text
  }

}
